import timezoneOptions from '../options/timezone';
import momentTimezone from 'moment-timezone';

import moment from 'moment';


const getTimeAbbr = () => {
  return momentTimezone().tz(momentTimezone.tz.guess()).zoneAbbr()
}

const phase1Fields = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Campaign Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  body: {
    value: '',
    error: null,
    name: 'body',
    placeholder: 'Text Message',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'textarea',
		charLimit: 50
  },
  days_before_lost: {
    value: '',
    error: null,
    name: 'days_before_lost',
    placeholder: 'Days Since Last Visit',
    breed: 'points',
    touched: false,
    isRequired: true,
    validationType: 'number',
    hasBlurred: false,
    inputType: 'text',
  }
  // campaign_type: {
  //   value: '',
  //   error: null,
  //   name: 'timezone',
  //   placeholder: 'Select Time Zone',
  //   breed: 'select',
  //   touched: false,
  //   isRequired: true,
  //   validationType: null,
  //   hasBlurred: false,
  //   inputType: 'text',
	// 	options: timezoneOptions
  // },
}

export default phase1Fields;



/** WEBPACK FOOTER **
 ** ./src/forms/autoCampaign/autoCampaignPhase2Lost.js
 **/